import { render } from "./ExpiredPage.vue?vue&type=template&id=e9d01546"
import script from "./ExpiredPage.vue?vue&type=script&lang=js"
export * from "./ExpiredPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__